<style scoped>
/*

    Guide des tailles recommendé pour material

    { font-size: 18px; }
    { font-size: 24px; }
    { font-size: 36px; }
    { font-size: 48px; }

*/

.Vector {
  fill: #000000;
  width: inherit;
  height: inherit;
}

.Vector svg {
  width: 100%;
  height: 100%;
}
</style>

<template>
  <div class="Vector" v-html="svg" :style="css"></div>
</template>

<script>
export default {
  props: {
    svg: {
      type: String,
      required: true
    },
    css:{
      default: () => ({})
    }
  }
};
</script>

